import { AHButton, AHText, Box } from "arkh";
import { useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { graphql, useMutation } from "react-relay";
import { StoreAdminNavigationScreenProps } from "../StoreAdmin/StoreAdminNavigation";
import { SelectDashboardList } from "./SelectDashboardList";
import { AddScreenAssignDashboardMutation } from "./__generated__/AddScreenAssignDashboardMutation.graphql";

export const AddScreenAssignDashboard = ({
  route: { params },
  navigation,
}: StoreAdminNavigationScreenProps<"AddScreenAssignDashboard">) => {
  const intl = useIntl();
  const safeAreaInsets = useSafeAreaInsets();
  const [dashboardId, setDashboardId] = useState<string | undefined>(
    params.fromStorecast?.id
  );

  const [saveDashboardId] = useMutation<AddScreenAssignDashboardMutation>(
    graphql`
      mutation AddScreenAssignDashboardMutation(
        $screenId: ID!
        $dashboardId: ID!
      ) {
        storecast {
          setScreenDashboard(screenId: $screenId, dashboardId: $dashboardId) {
            id
            name
            dashboard {
              id
              name
            }
          }
        }
      }
    `
  );

  const onSaveDashboardId = useCallback(() => {
    if (dashboardId !== undefined) {
      saveDashboardId({
        variables: {
          dashboardId,
          screenId: params.screenId,
        },
        onError: () => {},
        onCompleted: (data) => {
          if (!data.storecast.setScreenDashboard.dashboard) {
            return;
          }
          navigation.replace("AddScreenSuccess", {
            screenName: params.screenName,
            dashboardName: data.storecast.setScreenDashboard.dashboard.name,
            dashboardId: data.storecast.setScreenDashboard.dashboard.id,
            fromStorecast: params.fromStorecast,
          });
        },
      });
    }
  }, [
    dashboardId,
    navigation,
    params.fromStorecast,
    params.screenId,
    params.screenName,
    saveDashboardId,
  ]);

  return (
    <Box
      spaceHorizontal="large"
      spaceTop="large"
      spaceBottom="xlarge"
      style={{ height: "100%" }}
      insets={safeAreaInsets}
    >
      <AHText type="title-big" textAlign="center">
        <FormattedMessage
          description="StorecastAdminAddTVConfigureAssignDashboard title"
          defaultMessage="Pick a dashboard"
        />
      </AHText>
      <AHText
        type="list-item-title"
        spaceVertical="large"
        textAlign="center"
        color="text-secondary"
      >
        <FormattedMessage
          description="StorecastAdminAddTVConfigureAssignDashboard subtitle"
          defaultMessage="Which dashboard do you want to show on the screen?"
        />
      </AHText>
      <SelectDashboardList
        dashboardId={dashboardId}
        setDashboardId={setDashboardId}
        addDashboard={() =>
          navigation.replace("StorecastCreate", {
            assignScreenId: params.screenId,
          })
        }
      />
      <Box style={{ flex: 1 }} spaceTop="large" />
      <AHButton
        themeType="primary"
        disabled={dashboardId === undefined}
        onPress={onSaveDashboardId}
        title={intl.formatMessage({
          description: "StorecastAdminAddTVConfigureAssignDashboard done",
          defaultMessage: "Done!",
        })}
      />
    </Box>
  );
};
